import AddIcon from '@mui/icons-material/Add'
import { Button, LinearProgress } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { VitalsComponentEntryDialog } from 'src/clinic/components/ClinicManageBookingsPage/VitalsComponentEntryDialog'
import { getMPDataWithoutParams } from 'src/mentor/services'
import { VitalShowingComponent } from './VitalShowingComponent'
import { VitalsListingPageContainer } from './VitalsListingPageStyles'

export default function VitalsListingPage({ patientId, clinicId }) {
  const [vitalsData, setVitalsData] = useState([])
  const [loading, setLoading] = useState(false)
  const [createDialogOpen, setCreateDialogOpen] = useState(false)

  const getVitalsArray = useCallback(async () => {
    setLoading(true)
    const response = await getMPDataWithoutParams(
      `/api/secure/patient/vitals?patientId=${patientId}&clinicId=${clinicId}`,
    )
    setLoading(false)
    if (response.status === 200) {
      setVitalsData(response?.data?.data?.vital)
    }
  }, [patientId, clinicId])

  useEffect(() => {
    getVitalsArray()
  }, [getVitalsArray])

  return (
    <>
      {createDialogOpen && (
        <VitalsComponentEntryDialog
          patientId={patientId}
          clinicId={clinicId}
          closeFunction={() => setCreateDialogOpen(false)}
          callbackFunctionAfterSave={() => {
            setCreateDialogOpen(false)
            getVitalsArray()
          }}
        />
      )}
      {loading ? (
        <div>
          <LinearProgress color="secondary" />
        </div>
      ) : (
        <>
          {vitalsData?.length === 0 ? (
            <div>No vitals data</div>
          ) : (
            <VitalsListingPageContainer>
              <div className="w-100 d-flex" style={{ justifyContent: 'right' }}>
                <Button
                  color="emrPrimary"
                  variant="contained"
                  onClick={() => setCreateDialogOpen(true)}
                >
                  Record
                  <AddIcon />
                </Button>
              </div>
              {vitalsData?.map((vitalItem, vitalIndex) => (
                <VitalShowingComponent key={vitalIndex} vitalItem={vitalItem} />
              ))}
            </VitalsListingPageContainer>
          )}
        </>
      )}
    </>
  )
}


export function convertToFahrenheitFromCelsius(celsius) {
  return parseFloat(((celsius * 9) / 5 + 32).toFixed(1))
}

export function convertToCelsiusFromFahrenheit(fahrenheit) {
  return (((fahrenheit - 32) * 5) / 9).toFixed(1)
}

export function isVitalObjectValid(vitalItem) {
  if (
    !!vitalItem &&
    (vitalItem?.weightInGrams ||
      vitalItem?.sp02 ||
      vitalItem?.systolicBpInMmHg ||
      vitalItem?.diastolicBpInMmHg ||
      vitalItem?.bpm ||
      vitalItem?.tempInCelsius ||
      vitalItem?.heightInCms ||
      vitalItem?.bmi ||
      vitalItem?.waistHipRatio ||
      vitalItem?.respiratoryRatePerMin ||
      vitalItem?.rbsInMgPerDl ||
      vitalItem?.waistCircumferenceInCm ||
      vitalItem?.hipCircumferenceInCm ||
      vitalItem?.abdominalGirthInCm)
  ) {
    return true
  }
  return false
}
